import React, { Component } from "react";
import PropTypes from "prop-types";
import { Row, Col } from "react-bootstrap";
import utils from "@utils";
import ReportsTable from "./components/ReportsTable";
import {
	invoicePaymentColumns,
	jurisdictionFeePaymentColumns,
	clientPaymentColumns,
	locationPaymentColumns,
} from "./utils/columnsDefinition";

class DepartmentInvoiceReport extends Component {
	constructor(props) {
		super(props);
		this.state = {
			rateStats: [],
		};
	}

	componentDidMount() {
		const { data } = this.props;
		this.processRateStatusData(data || {});
	}

	componentDidUpdate({ data: prevData }) {
		const { data } = this.props;
		if (
			prevData?.TotalInvoiced !== data?.TotalInvoiced ||
			prevData?.TotalPaid !== data?.TotalPaid ||
			prevData?.TotalFeesInvoiced !== data?.TotalFeesInvoiced ||
			prevData?.TotalFeesPaid !== data?.TotalFeesPaid
		) {
			this.processRateStatusData(data || {});
		}
	}

	processRateStatusData = rawData => {
		const { lang } = global;
		const rateStats = [
			{
				id: 1,
				label: lang.t("Total Invoiced"),
				value: rawData.TotalInvoiced,
			},
			{
				id: 2,
				label: lang.t("Total Paid"),
				value: rawData.TotalPaid,
			},
			{
				id: 3,
				label: lang.t("Total Fees Invoiced"),
				value: rawData.TotalFeesInvoiced,
			},
			{
				id: 4,
				label: lang.t("Total Fees Paid"),
				value: rawData.TotalFeesPaid,
			},
		];
		this.setState({ rateStats });
	};

	renderRateStats = rateStats => {
		const { lang } = global;
		return (
			<div>
				<Row className="padding-top-20 hidden-print">
					<For
						each="item"
						of={rateStats}
					>
						<Col
							key={item.id}
							md={3}
							xs={3}
						>
							<div className="bg-white padding-15 rate-stats-upper-border rate-stats-bottom-border">
								<span className="rate-stats-label">{item.label}</span>
								<p className="rate-stats-value">
									{utils.currencyFormatter(item.value || 0)}
								</p>
							</div>
						</Col>
					</For>
				</Row>
				<Row className="visible-print margin-left-1">
					<div className="margin-top-10">
						<span className="color-dark font-regular report-table-header-title">
							{lang.t("Payment Summary")}
						</span>
					</div>
					<For
						each="item"
						of={rateStats}
					>
						<div
							key={item.id}
							className="flex"
						>
							<span className="font-light color-blue-bayoux flex-1">
								{item.label}
							</span>
							<span className="font-regular color-blue-bayoux flex-2">
								:{utils.currencyFormatter(item.value || 0)}
							</span>
						</div>
					</For>
				</Row>
			</div>
		);
	};

	render() {
		const { lang } = global;
		const { rateStats } = this.state;
		const { data, TimeZoneId, user } = this.props;

		return (
			<div className="panel reports-panel">
				<div className="panel-content">
					{this.renderRateStats(rateStats)}
					<ReportsTable
						header={lang.t("Fee Type Invoice Summary")}
						data={data.JurisdictionFeePaymentSummaries || []}
						tableColumn={jurisdictionFeePaymentColumns()}
					/>
					<ReportsTable
						header={lang.t("Client Payment Summary")}
						data={data.ClientPaymentSummaries || []}
						tableColumn={clientPaymentColumns()}
					/>
					<ReportsTable
						header={lang.t("Location Payment Summary")}
						data={data.LocationPaymentSummaries || []}
						tableColumn={locationPaymentColumns()}
					/>
					<ReportsTable
						header={lang.t("Invoice Payment Summary")}
						data={data.InvoicePaymentSummaries || []}
						tableColumn={invoicePaymentColumns(TimeZoneId, user)}
					/>
				</div>
			</div>
		);
	}
}

DepartmentInvoiceReport.propTypes = {
	TimeZoneId: PropTypes.string,
	data: PropTypes.array,
	user: PropTypes.any.isRequired,
};

DepartmentInvoiceReport.defaultProps = {
	TimeZoneId: "",
	data: [],
};

export default DepartmentInvoiceReport;
